<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card" ref="formContainer">
          <div class="card-body">
            <div v-for="(form, index) in forms" :key="index">
              <div class="row">
                <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Item Name</label>
                    <div>
                      <model-list-select
                        :list="itemListFromApi"
                        v-model="form.dispatchitem"
                        option-value="itemid"
                        option-text="itemname"
                        placeholder="Select item"
                        :ref="`dispatchitemInput${index}`"
                        tabindex="1"
                        autofocus
                        @keypress.enter="submitForm()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Department</label>
                    <div>
                      <model-list-select
                        :list="DeptList"
                        v-model="form.department"
                        option-value="deptid"
                        option-text="deptname"
                        placeholder="Select department"
                        @keypress.enter="submitForm()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Quantity</label>
                    <b-form-input type="number" v-model.number="form.quantity" min="0" max="999999.99" @input="validateQuantity(form)" @keypress.enter="submitForm()"/>
                  </div>
                </div>

                <div v-if="index === 0" class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Voucher Code</label>
                    <b-form-input type="text" v-model="form.vouchercode" @keypress.enter="submitForm()"/>
                  </div>
                </div>
                <div v-if="index === 0" class="col-lg-4 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Issue Date</label>
                    <div>
                      <b-form-input
                        type="date"
                        v-model="form.dispatchdate"
                        placeholder="Select dispatch date"
                        @keypress.enter="submitForm()"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class ="col-lg-12">
                  <button v-if="index > 0" @click="removeForm(index)" class="btn btn-danger mb-3">Remove</button>
                </div>
              </div>
              <hr style="border-top: 4px solid #000; margin: 10px 0;"/>
            </div>
            <button @click="addForm" class="btn btn-success me-2">Add More</button>
            <button @click="submitForms" class="btn btn-primary me-2" >Submit All</button>
            <router-link to="saleslist" class="btn btn-secondary">Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import Swal from "sweetalert2";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';

export default {
  data() {
    return {
      forms:[
        {
          dispatchitem: '',
          quantity: '0',
          vouchercode: '',
          department: '',
          dispatchdate: '',
        },
      ],
      title: "Issue Item",
      title1: "Create new Issue Item",
      DeptList: [],
      itemListFromApi: [],
    };
  },
  created(){
    this.fetchItemListFromApi();
    this.fetchDeptListFromApi();
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    this.$nextTick(() => {
      this.$refs.firstInput.focus();
    });
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/add-sales' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault();
        this.addForm();
      }
    },
    validateQuantity(form) {
      const quantity = parseFloat(form.quantity);
      if (quantity < 0) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Quantity',
          text: 'Quantity must be a positive number.',
        });
        form.quantity = Math.max(quantity, 0);
      }
    },
    addForm() {
      if (this.forms.length < 20) {
        this.forms.push({
          dispatchitem: '',
          quantity: '0',
          department: '',
        });
        this.$nextTick(() => {
        const newIndex = this.forms.length - 1;
        console.log("new insex is", newIndex);
        this.$refs[`dispatchitemInput${newIndex}`][0].$el.focus();
        this.scrollToBottom();
      });
      }
      if (this.forms.length >= 20) {
        Swal.fire("You can add a maximum of 20 forms.");
      }
    },
    removeForm(index) {
      this.forms.splice(index, 1);
    },
    async fetchItemListFromApi() {
      try {
        const response = await axios.get('/v1/items');
        this.itemListFromApi = response.data; // Update with your actual API response structure
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },
    async fetchDeptListFromApi() {
      try {
        const response = await axios.get('/v1/departments');
        this.DeptList = response.data; // Update with your actual API response structure
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },
    async submitForms() {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
        const allFormData = [];
        const firstForm = this.forms[0];

        this.forms.forEach(form => {
          const selectedDate = moment(firstForm.dispatchdate).format("YYYY-MM-DD")
          const currentTime = moment().format("HH:mm:ss");

          allFormData.push({
            dispatchitem: form.dispatchitem,
            quantity: form.quantity,
            vouchercode: firstForm.vouchercode,
            department: form.department,
            dispatchdate: `${selectedDate}T${currentTime}`,
          });
        });

        this.postData(allFormData);
      }
    },
    postData(forms) {
      axios
        .post('/v1/dispatches', forms)
        .then(response => {
//this.res = "Status " + response.status + ". Category created";
          Swal.fire("Issue Item created successfully");
          this.$router.push({ path: '/saleslist' });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(error.response.data.detail);
        });
    },
    submitForm() {
      this.submitForms();
    }

  },
  components: {
    ModelListSelect
  },

  name: "add-sales",
};
</script>  